'use client';

// import Image from '../image';
import { handleLinkByType } from '@/utils/global';
import { useLocale } from 'next-intl';
import Image from '../image';
import NextLink from '../next-link';
// import { BannerEvent } from '../GTM';

const HomeBanner = ({ data = [], isMobile }) => {
  const locale = useLocale();
  const length =
    data?.length === 1
      ? 'grid-cols-1'
      : data?.length === 2
        ? 'grid-cols-1 md:grid-cols-2'
        : data?.length === 3
          ? 'grid-cols-1 md:grid-cols-3'
          : 'grid-cols-1 md:grid-cols-4';

  return (
    <section
      className={`mx-auto my-6 grid w-11/12 max-w-[1536px] max-md:my-4 ${length} gap-5 max-md:gap-2`}
    >
      {data?.map((info, index) => (
        <NextLink
          prefetch={false}
          // onClick={() =>
          //   BannerEvent(
          //     isMobile
          //       ? info?.[`mobile-img-${locale}`]
          //       : info?.[`img-${locale}`],
          //     info?.url
          //   )
          // }
          href={handleLinkByType(info?.url, info?.type)}
          key={index}
          className='overflow-hidden rounded-xl'
        >
          <Image
            loading='lazy'
            src={
              isMobile
                ? info?.[`mobile-img-${locale}`]
                : info?.[`img-${locale}`]
            }
            className='h-auto w-full cursor-pointer rounded-xl object-contain transition-all duration-500 hover:scale-105'
            alt='Banner Img!'
          />
        </NextLink>
      ))}
    </section>
  );
};

export default HomeBanner;
